module.exports = "/_next/static/images/8-9a4919e4067b491f0a3080c0abfae07c.gif";